export const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const indianNumberRegex = /^(0|91)?[6-9][0-9]{10}$/;
